<template>
  <!--  <d-container fluid class="main-content-container px-4"> -->
  <div class="main-content-container">
    <div class="container">
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Alterar Acesso</h3>
        </div>
      </div>
      <div class="row equal-cols">
        <d-col class="mb-12 col-lg-12 lg-s">
          <d-row>
            <d-col v-if="$isAuthorize('UserInternal', 'UpdateMerchant')" class="mb-6 col-lg-6 lg-s">
              <d-card class="card-small edit-user-details mb-4">
                <d-card-body class="p-0">
                  <div class="border-bottom clearfix d-flex">
                    <d-nav tabs class="border-0 mt-auto mx-4 pt-2">
                      <h6>Empresa</h6>
                      <hr />
                    </d-nav>
                  </div>
                  <d-form class="py-4">
                    <d-form-row class="mx-4">
                      <d-col lg="8">
                        <d-form-row>
                          <!-- Name -->
                          <d-col md="6" class="form-group">
                            
                            <d-input
                              type="text"
                              id="name"
                              v-model="Merchant.Id"
                              placeholder="Id Merchant"
                            />
                          </d-col>

                          <!-- Save -->
                          <d-col md="6" class="form-group">
                            <button
                              class="btn btn-outline-secondary"
                              type="button"
                              aria-haspopup="true"
                              aria-expanded="false"
                              v-on:click="UpdateMerchant(Merchant.Id)"
                            >
                              Salvar
                            </button>
                          </d-col>
                        </d-form-row>
                      </d-col>
                    </d-form-row>
                  </d-form>
                </d-card-body>
              </d-card>
            </d-col>
            <d-col v-if="$isAuthorize('UserPartner', 'UpdatePartner')" class="mb-6 col-lg-6 lg-s">
              <d-card class="card-small edit-user-details mb-4">
                <d-card-body class="p-0">
                  <!-- Nav Wrapper -->
                  <div class="border-bottom clearfix d-flex">
                    <d-nav tabs class="border-0 mt-auto mx-4 pt-2">
                      <h6>Parceiro</h6>
                      <hr />
                    </d-nav>
                  </div>
                  <d-form class="py-4">
                    <d-form-row class="mx-4">
                      <d-col lg="8">
                        <d-form-row>
                          <!-- Name -->
                          <d-col md="6" class="form-group">
                            <d-input
                              type="text"
                              id="name"
                              v-model="Partner.Id"
                              placeholder="Id Partner"
                            />
                          </d-col>

                          <!-- Save -->
                          <d-col md="6" class="form-group">
                            <button
                              class="btn btn-outline-secondary"
                              type="button"
                              aria-haspopup="true"
                              aria-expanded="false"
                              v-on:click="UpdatePartner(Partner.Id)"
                            >
                              Salvar
                            </button>
                          </d-col>
                        </d-form-row>
                      </d-col>
                    </d-form-row>
                  </d-form>
                </d-card-body>
              </d-card>
            </d-col>
          </d-row>
          <br />
        </d-col>
      </div>
    </div>
  </div>
  <!-- </d-container> -->
</template>

<script>
import TagsInput from "@johmun/vue-tags-input";
import "@/assets/scss/vue-tags-input.scss";
import { FileToBase64 } from "../../utils/fileUtils.js";
export default {
  name: "change-access",
  components: {
    TagsInput,
  },
  data() {
    return {
      loading: false,
      Merchant: {
        Id: null,
      },
      Partner: {
        Id: null,
      },
    };
  },
  methods: {
    UpdateMerchant(Id) {
      this.$store
        .dispatch("UpdateUserInternalMerchant", this.Merchant )
        .then(() => {
          this.$makeToast(
            "O Id Merchant foi atualizado com sucesso.",
            "success",
            "Acesso atualizado"
          );
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao atualizar o Id Merchant",
            error
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    UpdatePartner(idPartner) {
      this.$store
        .dispatch("UpdateUserPartnerInternal", this.Partner)
        .then(() => {
          this.$makeToast(
            "O Id Partner foi atualizado com sucesso.",
            "success",
            "Acesso atualizado"
          );
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao atualizar o Id Partner",
            error
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style>
#imgUser {
  height: 120px;
  width: 120px;
}
#legendChangeImg {
  margin-top: 5px;
  font-size: 0.7em;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/changeAccess.vue